(function () {
    'use strict';

    angular
        .module('fauzanKhanQueryBuilder')
        .constant('QB_CONSTANTS', {
            'FILTER_MODE': 1,
            'EQUATION_MODE': 2,
            'ALLOW_CUSTOM_QUERY': true,
            'DISALLOW_CUSTOM_QUERY': false,
        });
})();